import { render } from "./index.vue?vue&type=template&id=83108c1c"
const script = {}

import exportComponent from "G:\\workspace\\hitarget-offical\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__